import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    required,
} from 'react-admin';
import { SheetCreateComponent } from '.';

export const SheetCreate = () => (
    <Create component={SheetCreateComponent}>
        <SimpleForm>
            <TextInput source="name" validate={required()}/>
        </SimpleForm>
    </Create>
);